function init() {
  const menuItems = document.querySelectorAll('.mice-header .main-nav .menu_item.has-children')

  if (!menuItems || menuItems.length === 0) {
    return
  }

  menuItems.forEach(element => {
    element.addEventListener('click', e => {
      const target = e.currentTarget
      const dropdownLinks = target.querySelector('.drop-down-links')

      if (target.classList.contains('active')) {
        target.classList.remove('active')
        dropdownLinks.style.display = 'none'
      } else {
        target.classList.add('active')
        dropdownLinks.style.display = 'block'

        // Add clickaway event only if not already active
        document.addEventListener('click', event => handleClickOutside(event, menuItems))
      }
    })
  })
}
function handleClickOutside(event, menuItems) {
  menuItems.forEach(item => {
    if (!item.contains(event.target)) {
      item.classList.remove('active')
      const dropdownLinks = item.querySelector('.drop-down-links')
      dropdownLinks.style.display = 'none'
    }
  })

  // Remove the listener after handling the click
  document.removeEventListener('click', event => handleClickOutside(event, menuItems))
}
init()
